<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="赛事编号" prop="competitionId" >
        <a-input v-model="form.competitionId" placeholder="请输入赛事编号" />
      </a-form-model-item>
      <a-form-model-item label="封面图片" prop="image" >
        <file-upload v-model="form.image" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="链接地址" prop="linkUrl" >
        <a-input v-model="form.linkUrl" placeholder="请输入链接地址" />
      </a-form-model-item>
      <a-form-model-item label="截至时间" prop="cutDate" >
        <a-input v-model="form.cutDate" placeholder="请输入截至时间" />
      </a-form-model-item>
      <a-form-model-item label="数量" prop="num" >
        <a-input v-model="form.num" placeholder="请输入数量" />
      </a-form-model-item>
      <a-form-model-item label="剩余数量" prop="surplusNum" >
        <a-input v-model="form.surplusNum" placeholder="请输入剩余数量" />
      </a-form-model-item>
      <a-form-model-item label="名称及说明" prop="message" >
        <a-input v-model="form.message" placeholder="请输入名称及说明" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompetitionPacket, addCompetitionPacket, updateCompetitionPacket } from '@/api/platform/competitionPacket'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        competitionId: null,

        image: null,

        linkUrl: null,

        cutDate: null,

        num: null,

        surplusNum: null,

        message: null,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        competitionId: null,
        image: null,
        linkUrl: null,
        cutDate: null,
        num: null,
        surplusNum: null,
        message: null,
        sort: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompetitionPacket({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompetitionPacket(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompetitionPacket(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
